




















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ItemsGrid extends Vue {
  @Prop({ default: [] })
  public items!: any[];

  @Prop({ default: 18 })
  public limit!: number;

  @Prop({ required: true })
  public title!: string;

  @Prop({ default: false })
  public isHalfSplitted!: boolean;

  // Computed

  public get visibleItems() {
    return this.items.slice(0, this.limit);
  }

  public get showShowMoreButton() {
    return this.limit < this.items.length;
  }
}
